import React, { Component, PropTypes } from 'react';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import './Login.css';
import LoginStyles from './LoginStyles';

class Login extends Component {
    constructor(props) {
        super(props);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
        console.log("Constructor login");
        this.state = {
            password: ''
        }
    }

    onChangePassword(event) {
        this.setState({
            password: event.target.value
        });
    }
    validatePassword() {
        if (this.state.password === 'aguamonitorpass') {
            this.props.enterToDashboard();
        } else {
            alert("Contraseña incorrecta.");
            this.setState({
                password: ''
            });
        }
    }
    render() {
        return (
            <div className="login-container">
                <TextField
                    style={LoginStyles.textfield}
                    hintText="Contraseña"
                    floatingLabelText="Contraseña"
                    type="password"
                    value={this.state.password}
                    onChange={this.onChangePassword}
                />
                <RaisedButton
                    className="login-button"
                    label="Entrar"
                    primary={true}
                    style={LoginStyles.button}
                    onClick={this.validatePassword}
                />
            </div>

        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Components/Login/Login.jsx